import React from "react";
import { observer } from "mobx-react";
import { MusicalGenreViewStore } from "../../store";
import { MusicalGenreViewForm } from "./MusicalGenreViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type MusicalGenreViewProps = {
  musicalGenreViewStore: MusicalGenreViewStore;
};

export const MusicalGenreView: React.FC<MusicalGenreViewProps> = observer(
  ({ musicalGenreViewStore }) => {
    return (
      <div>
        <MusicalGenreViewForm
          name={musicalGenreViewStore.nameValue}
          onPrint={(handlePrint: () => void) =>
            musicalGenreViewStore.printMusicalGenre(handlePrint)
          }
          onCancel={() => musicalGenreViewStore.cancelMusicalGenre()}
          onEdit={
            musicalGenreViewStore.isEditEnabled
              ? () => musicalGenreViewStore.editMusicalGenre()
              : undefined
          }
        />
        <ErrorDialog
          open={musicalGenreViewStore.errorDialogOpened}
          title={musicalGenreViewStore.errorTitle}
          description={musicalGenreViewStore.errorDescription}
          onClose={() => musicalGenreViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
